import React from 'react';
import { useTranslation } from 'react-i18next';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

interface TabsProps {
  edit: boolean;
  view: boolean;
  tab: string;
  onTabChange: (e: any, tab: string) => void;
  filesDisabled?: boolean;
}

const FormTabs: React.FC<TabsProps> = ({ edit, view, tab, onTabChange, filesDisabled }) => {
  const { t } = useTranslation();

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    onTabChange(event, newValue);
  };

  return (
    <div className="card-header overflow-hidden no-padding">
      <Tabs value={tab} onChange={handleChange} textColor="primary">
        <Tab
            value="propertyDetails"
            label={
                <div className="d-flex align-items-center">
                    <i className="ri-building-line me-2"></i>
                    {t('properties.addEdit.pageTexts.form.tabs.propertyDetails')}
                </div>
            }
        />
        <Tab
            value="files" 
            label={
                 <div className="d-flex align-items-center">
                    <i className="ri-file-list-3-line me-2"></i>
                    {t('properties.addEdit.pageTexts.form.tabs.files')}
                </div>
            }
            disabled={filesDisabled}
        />
      </Tabs>
    </div>
  );
};

export default FormTabs;
